import * as React from "react";
import { singleton } from "logic/singleton";
const SelectableMessageTableMessagesContext = React.createContext(
  void 0
);
export default singleton(
  "contexts.views.SelectableMessageTableMessagesContext",
  () => SelectableMessageTableMessagesContext
);
